
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.8726 6.59192L9.17452 18.29L3 12.1155L4.30192 10.8136L9.17452 15.6862L19.5707 5.29L20.8726 6.59192Z" fill="currentColor"></path></svg>';export default svg;
    